import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './Card.css';

type Props = {
    cardLabel: {
        key: string;
        value: string;
    };
    cardDesc: {
        key: string;
        value: string;
    };
    cardFooter: {
        key: string;
        value: string;
    };
};

const Card = ({ cardLabel, cardDesc, cardFooter }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={styles.ruleTesterCard}>
            <div className={styles.cardHead}>{cardLabel.value}</div>
            <p className={styles.cardLabel}>{t(cardLabel.key)}</p>

            <div className={styles.cardDesc}>
                <p>
                    {`${t(cardDesc.key)}: `}
                    <b>{cardDesc.value}</b>
                </p>
                <p>
                    {`${t(cardFooter.key)}: `}
                    <b>{cardFooter.value}</b>
                </p>
            </div>
        </div>
    );
};

export default Card;
